import React, { useState, useEffect } from "react";
import "./SuccessMessage.css";

const SuccessMessage = () => {
    const [message, setMessage] = useState("");
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // دالة لعرض رسالة النجاح
        window.showSuccessMessage = (msg) => {
            setMessage(msg);
            setIsVisible(true);
            
            // إخفاء الرسالة بعد 3 ثواني
            setTimeout(() => {
                setIsVisible(false);
            }, 3000);
        };

        return () => {
            delete window.showSuccessMessage;
        };
    }, []);

    if (!isVisible) return null;

    return (
        <div className="success-message-overlay">
            <div className="success-message">
                <div className="success-icon">✓</div>
                <div className="success-text">{message}</div>
            </div>
        </div>
    );
};

export default SuccessMessage; 